import React from 'react'
import { DataTable, Button, Table } from '@arnsbogroup/react-voicearchive'
import messages from './messages'
import { FormattedMessage, useIntl } from 'react-intl'
import { Span } from 'components/datatable'

const ReportResults = ({
    loading = false,
    selectedTaskIds = [],
    onTaskSelected = () => {},
    entries = [],
    onMarkAsPaid = () => {},
    showFullTaskRow = false
}) => {
    const { formatMessage } = useIntl()

    const getHead = () => {
        return showFullTaskRow ? {
            customer_uid: { label: formatMessage(messages.customerId) },
            customer_country: { label: formatMessage(messages.customerCountry) },
            customer_country_id: { label: formatMessage(messages.customerCountryId) },
            customer_partner: { label: formatMessage(messages.customerPartner) },
            customer_submission_id: { label: formatMessage(messages.customerSubmissionId) },
            customer_accounting_id: { label: formatMessage(messages.customerAccountingId) },
            customer_name: { label: formatMessage(messages.customerName) },
            order_uid: { label: formatMessage(messages.orderUid) },
            order_partner: { label: formatMessage(messages.orderPartner) },
            order_created: { label: formatMessage(messages.orderCreated) },
            task_uid: { label: formatMessage(messages.taskId) },
            task_created: { label: formatMessage(messages.taskCreated) },
            target_language: { label: formatMessage(messages.targetLanguage) },
            source_language: { label: formatMessage(messages.sourceLanguage) },
            supplier: { label: formatMessage(messages.supplier) },
            type_name: { label: formatMessage(messages.typeName) },
            type_id: { label: formatMessage(messages.typeId) },
            cost: { label: formatMessage(messages.cost) },
            cost_currency: { label: formatMessage(messages.costCurrency) },
            price: { label: formatMessage(messages.price) },
            price_currency: { label: formatMessage(messages.priceCurrency) },
            discount_percentage: { label: formatMessage(messages.discountPercentage) },
            net_sales: { label: formatMessage(messages.netSales) },
            closed: { label: formatMessage(messages.closed) },
            invoiced: { label: formatMessage(messages.invoiced) },
            retake_id: { label: formatMessage(messages.retakeId) },
            retake_name: { label: formatMessage(messages.retakeName) },
            creditor_nr: { label: formatMessage(messages.creditorNr) },
            date: { label: formatMessage(messages.date) },
        } : {
            customer_name: { label: formatMessage(messages.customerName) },
            order_uid: { label: formatMessage(messages.orderUid) },
            task_uid: { label: formatMessage(messages.taskId) },
            task_created: { label: formatMessage(messages.taskCreated) },
            supplier: { label: formatMessage(messages.supplier) },
            type_name: { label: formatMessage(messages.typeName) },
            cost: { label: formatMessage(messages.cost) },
            cost_currency: { label: formatMessage(messages.costCurrency) },
            price: { label: formatMessage(messages.price) },
            price_currency: { label: formatMessage(messages.priceCurrency) },
            discount_percentage: { label: formatMessage(messages.discountPercentage) },
            closed: { label: formatMessage(messages.closed) },
            invoiced: { label: formatMessage(messages.invoiced) },
        }
    }
    
    const getBody = () => {
        return showFullTaskRow ? {
            customer_uid: Span,
            customer_country: Span,
            customer_country_id: Span,
            customer_partner: Span,
            customer_submission_id: Span,
            customer_accounting_id: Span,
            customer_name: Span,
            order_uid: Span,
            order_partner: Span,
            order_created: Span,
            task_uid: Span,
            task_created: Span,
            target_language: Span,
            source_language: Span,
            supplier: Span,
            type_name: Span,
            type_id: Span,
            cost: Span,
            cost_currency: Span,
            price: Span,
            price_currency: Span,
            discount_percentage: Span,
            net_sales: Span,
            closed: Span,
            invoiced: Span,
            retake_id: Span,
            retake_name: Span,
            creditor_nr: Span,
            date: Span,
        } : {
            customer_name: Span,
            order_uid: Span,
            task_uid: Span,
            task_created: Span,
            supplier: Span,
            type_name: Span,
            cost: Span,
            cost_currency: Span,
            price: Span,
            price_currency: Span,
            discount_percentage: Span,
            closed: Span,
            invoiced: Span
        }
    }
    

    return (
        <div className="w-full">
            {!!selectedTaskIds.length &&
                <div className='m-2'>
                    <Button
                        disabled={loading}
                        onClick={() => onMarkAsPaid(selectedTaskIds)}
                        size="base"
                    >
                        <FormattedMessage {...messages.markAsPaid} />
                    </Button>
                </div>
            }
            <div className="grow overflow-y-scroll">
                <DataTable
                    noDataMessage={formatMessage(messages.noData)}
                    rowSelectionKey="task_uid"
                    rowsSelected={selectedTaskIds}
                    onRowSelected={(id) => onTaskSelected(id)}
                    components={{
                    Tr: ({ childProps = {}, ...props }) => (
                        <Table.Tr
                        title={!(+childProps?.creditor_nr) ? formatMessage(messages.missingSupplierCreditorId) : null}
                        className={`cursor-pointer ${childProps?.supplier && !(+childProps?.creditor_nr) ? 'bg-red-100' : ''}`}
                            onClick={() => window.open(`/task/${childProps?.task_uid}`, '_blank')}
                            {...props }
                        />
                        )
                    }}
                    head={getHead()}
                    body={getBody()}
                    entries={entries}
                />
            </div>
        </div>
    )
}

export default ReportResults
